export default "__VITE_ASSET__92b84bf8__"